export const Countries = [
  'Australia',
  'Bali',
  'Dubai',
  'Europe',
  'Hong Kong',
  'Malaysia',
  'Maldives',
  'Mauritius',
  'New Zealand',
  'Seychelles',
  'Singapore',
  'South Africa',
  'Sri Lanka',
  'Switzerland',
  'Thailand',
  'Turkey',
  'Singapore + Bali',
  'Singapore + Malaysia',
  'Others international',
  'Bhutan',
  'Africa',
  'Egypt',
  'Cambodia',
  'Vietnam',
  'Nepal',
  'CIS Countries',
  'Iceland',
  'Kenya',
  'Azerbaijan',
  'UAE',
  'China',
  'Japan',
  'Canada',
  'Israel',
  'USA',
  'Russia',
  'Myanmar',
  'Jordan',
  'Uzbekistan'
];
